import { useState } from "react";
import { TiStar ,TiStarHalf} from "react-icons/ti";
import styles from './rating.module.css';


const Ratings = ({ rating = 0, setRating, editable = false, count }) => {
  const [hovered, setHovered] = useState(0);

  const handleMouseEnter = (index) => {
    if (!editable) return;
    setHovered(index);
  };

  const handleMouseLeave = () => {
    if (!editable) return;
    setHovered(0);
  };

  const handleClick = (index) => {
    if (!editable || !setRating) return;
    setRating(index);
  };

  const renderStars = () => {
    const stars = [];
    const displayRating = hovered || rating;

    for (let i = 1; i <= 5; i++) {
      stars.push(
        <span
          key={i}
          className={styles.icon}
          onMouseEnter={() => handleMouseEnter(i)}
          onMouseLeave={handleMouseLeave}
          onClick={() => handleClick(i)}
          style={{ cursor: editable && setRating ? "pointer" : "default" }}
        >
          {displayRating >= i ? (
            <TiStar size={18} fill="#FFCC00" strokeWidth={0} />
          ) : (
            <TiStar size={18} fill="transparent" stroke="#FFCC00" strokeWidth={1} />
          )}
        </span>
      );
    }
    return stars;
  };

  return (
    <div className={styles.container}>
      {count ? <span className={styles.count}>{count}</span> : null}
      {renderStars()}
    </div>
  );
};

export default Ratings;
